import React, { Component } from 'react';
import {
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Grid,
  Fab
} from '@material-ui/core';

import PropTypes from 'prop-types';
import EditIcon from '@material-ui/icons/Edit';
import ErrorIcon from '@material-ui/icons/Error';
import i18n from '../../i18n';

import {
  convertUnixTimeToDateString,
  isOverFourMonths
} from '../../helpers/helpers';
import SaveCancelContainer from '../SaveCancelContainer';
import BoolModelMeasurement from './BoolModelMeasurement';
import NumericModelMeasurement from './NumericModelMeasurement';
import ShoeSizeMeasurement from './ShoeSizeMeasurement';
import { sanitizeFloats } from '../../helpers/inputHelpers';

const measurementTypes = {
  rightEarPierced: BoolModelMeasurement,
  leftEarPierced: BoolModelMeasurement,
  shoeSize : ShoeSizeMeasurement,
}
class ModelMeasurement extends Component {
  static sanitizeData(modelMeasurementData) {
    const sanitizedData = {};
    Object.keys(modelMeasurementData).forEach(key => {
      if(measurementTypes[key] === measurementTypes.shoeSize) {
        const shoeSize = sanitizeFloats(modelMeasurementData[key].shoeSize);
        const shoeSizeEU = sanitizeFloats(modelMeasurementData[key].shoeSizeEU)
        sanitizedData[key] = {...modelMeasurementData[key], shoeSize, shoeSizeEU }
      } else {
        sanitizedData[key] = modelMeasurementData[key];
      }
    });
    return sanitizedData;
  }

  constructor(props) {
    super(props);

    this.state = {
      inEditMode: false,
      modelMeasurementData: props.modelmeasurement,
      saving: false,
    };

    this.initialModelMeasurementData = props.modelmeasurement;
  }

  toggleEditMode = () => {
    this.setState(prevstate => ({ inEditMode: !prevstate.inEditMode }));
  };

  cancelEdit = () => {
    this.setState({
      inEditMode: false,
      modelMeasurementData: this.initialModelMeasurementData,
      saving: false
    });
  };

  /**
   * 
   * @param {object} newMeasurement 
   * @param {string} measurementType 
   */
  handleModelMeasurementChange = (newMeasurement, measurementType) => {
    this.setState(prevstate => {
      const measurementData = JSON.parse(
        JSON.stringify(prevstate.modelMeasurementData)
      );

      measurementData[measurementType] = newMeasurement;
      measurementData[measurementType][`${measurementType}LastUpdatedAt`] =
        new Date().getTime() / 1000;
      return { modelMeasurementData: measurementData };
    });
  };

  submitForm = () => {
    const { modelMeasurementData } = this.state;
    const { onSubmitModelMeasurementChange } = this.props;
    const sanitizedData = ModelMeasurement.sanitizeData(modelMeasurementData);
    this.setState({ saving: true })

    onSubmitModelMeasurementChange(sanitizedData)
      .then(() => {
        this.setState(
          { inEditMode: false, saving: false },
          () => {
            this.baseState = this.state;
          }
        );
      })
      .catch(() => this.cancelEdit());
  };

  render() {
    const { modelMeasurementData, inEditMode, saving } = this.state;

    return (
      <>
        <Paper className="modelMeasurement">
          <div>
            <br />
            {!inEditMode && (
              <Grid item xs={1} className="measurementEditButton">
                <Fab
                  variant="extended"
                  size="small"
                  color="primary"
                  aria-label="edit"
                  onClick={this.toggleEditMode}
                >
                  <EditIcon color="secondary" />
                </Fab>
              </Grid>
            )}
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{i18n.t('userProfile:measurement')}</TableCell>
                  <TableCell className="centerMeasurement">
                    {i18n.t('userProfile:modelMeasurements')}
                  </TableCell>
                  <TableCell>{i18n.t('userProfile:lastUpdated')}</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(modelMeasurementData).map(key => {
                  const MeasurementType = measurementTypes[key] || NumericModelMeasurement;
                  return (
                    <React.Fragment key={key}>
                      <TableRow key={key}>
                        <TableCell component="th" scope="row">
                          <Typography>{i18n.t(`userProfile:${key}`)}</Typography>
                        </TableCell>
                        <TableCell>
                          <MeasurementType 
                            measurementKey={key}
                            inEditMode={inEditMode}
                            modelMeasurement={modelMeasurementData[key]}
                            handleModelMeasurementChange={this.handleModelMeasurementChange}
                          />
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Typography>
                            {convertUnixTimeToDateString(
                              modelMeasurementData[key][`${key}LastUpdatedAt`]
                            )}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <span>
                            {isOverFourMonths(
                              modelMeasurementData[key][`${key}LastUpdatedAt`], new Date()
                            ) && <ErrorIcon className="overFourMonthOld" />}
                          </span>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>)
                })}
              </TableBody>
            </Table>
            <br />
            {inEditMode && (
              <SaveCancelContainer
                onSave={this.submitForm}
                onCancel={this.cancelEdit}
                saving={saving}
              />
            )}
          </div>
        </Paper>
      </>
    );
  }
}

ModelMeasurement.propTypes = {
  modelmeasurement: PropTypes.objectOf(PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]))).isRequired,
  onSubmitModelMeasurementChange: PropTypes.func.isRequired
};

export default ModelMeasurement;
